export default {
  title: '気に入り',
  no_collection: '気に入り商品が登録されていません',
  reward_points: 'ﾎﾟｲﾝﾄ{num}倍',
  productStockStatus: '在庫わずか',
  disposals: '処分品',
  full_minus: '定額割引(￥)',
  full_discount_coupon: '%OFF券',
  full_coupon_reduction: '円OFF券',
  parcel_post_voucher: '送料無料券',
  replenishment: '入荷待ち',
  to_end: 'これ以上がありません',
  success: 'カートに入れました!',
  fail: 'カートに入れる時にエラーが発生しました!',
  del_success: '気に入りから外しました!',
  bunding: '同梱'
};